// ─────────────────────────────────────────────────────────────────────────────
// constants.ts — ContentSectionEditPageCareer
// ─────────────────────────────────────────────────────────────────────────────
import { ActiveSection } from './types';

export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];

export const SECTION_HUMAN: Record<ActiveSection, string> = {
  heroSection:           'Hero',
  positionSection:       'Position',
  submissionStepSection: 'Submission Step',
};

export const SECTION_KEY: Record<ActiveSection, string> = {
  heroSection:           'CR-001',
  positionSection:       'CR-002',
  submissionStepSection: 'CR-003',
};